/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('../bootstrap');
require('../plugins');

// import 'alpinejs'
import Alpine from 'alpinejs'

window.Alpine = Alpine

Alpine.start()

/*
 |--------------------------------------------------------------------------
 | 3rd Party Libraries
 |--------------------------------------------------------------------------
 |
 | Import 3rd party library JS files.
 |
 */

import "./../theme/tw-starter";

import "./../theme/chart";
// import "./../theme/chart3";
// import "./../theme/highlight";
import "./../theme/feather";
// import "./../theme/tiny-slider";
import "./../theme/tippy";
import "./../theme/datepicker";
import "./../theme/tom-select";
// import "./../theme/dropzone";
// import "./../theme/ckeditor";
import "./../theme/validation";
// import "./../theme/zoom";
import "./../theme/notification";
import "./../theme/fold";
// import "./../theme/tabulator";
// import "./../theme/calendar";

/*
 |--------------------------------------------------------------------------
 | Components
 |--------------------------------------------------------------------------
 |
 | Import JS components.
 |
 */
// import "./../theme/maps";
// import "./../theme/chat";
// import "./../theme/show-modal";
// import "./../theme/show-slide-over";
// import "./../theme/show-dropdown";
import "./../theme/dropdown";
// import "./../theme/search";
// import "./../theme/copy-code";
// import "./../theme/show-code";
import "./../theme/side-menu";
import "./../theme/mobile-menu";
import "./../theme/side-menu-tooltip";
import "./../theme/dark-mode-switcher";

import "./../theme/filepond";

// import Vue from 'vue';

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

// Vue.component('example-component', require('./components/ExampleComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// const app = new Vue({
//     el: '#app',
// });
